import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SiteHeader from './SiteHeader';
import Footer from './Footer';
import { trackPageView } from '../utils/tracking';

function BlogList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPosts();
    trackPageView('Blog List');
  }, []);

  const fetchPosts = async () => {
    try {
      const response = await fetch('/api/blog/posts');
      if (!response.ok) {
        throw new Error('Failed to fetch posts');
      }
      const data = await response.json();
      setPosts(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-GB', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="page-wrapper" style={{ minHeight: '100vh', backgroundColor: '#FAFAFA' }}>
      <SiteHeader />
      <main className="main-wrapper">
        <section style={{ padding: '50px 20px 20px' }}>
          <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
            <h1 style={{
              fontSize: '2.25rem',
              fontWeight: '800',
              background: 'linear-gradient(135deg, #8B5FBF, #6B46C1)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              marginBottom: '16px',
              lineHeight: '1.2',
              paddingBottom: '0.1em',
            }}>
              The OkGather Blog
            </h1>
            <p style={{ color: '#4B5563', fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '28px' }}>
              Guides to meeting people, making friends, and finding your crowd in cities across the UK -
              from casual social gatherings to industry-specific networks like our tech meetups.
            </p>
            <Link
              to="/events"
              style={{
                display: 'inline-block',
                background: 'linear-gradient(135deg, #8B5FBF, #2c2e96)',
                color: '#fff',
                padding: '14px 32px',
                borderRadius: '25px',
                textDecoration: 'none',
                fontSize: '1rem',
                fontWeight: '600',
                boxShadow: '0 2px 10px rgba(139, 95, 191, 0.2)',
              }}
            >
              Browse Gatherings
            </Link>
          </div>
        </section>

        <section style={{ padding: '20px 20px 60px' }}>
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            {loading && (
              <p style={{ textAlign: 'center', color: '#666' }}>Loading posts...</p>
            )}

            {error && (
              <p style={{ textAlign: 'center', color: 'red' }}>Error: {error}</p>
            )}

            {!loading && !error && posts.length === 0 && (
              <p style={{ textAlign: 'center', color: '#666' }}>
                No blog posts yet. Check back soon!
              </p>
            )}

            {!loading && !error && posts.length > 0 && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                {posts.map((post) => (
                  <Link
                    key={post.id}
                    to={`/blog/${post.slug}`}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    <article
                      style={{
                        padding: '28px',
                        borderRadius: '16px',
                        border: '1px solid rgba(139, 95, 191, 0.15)',
                        backgroundColor: '#fff',
                        transition: 'box-shadow 0.2s ease, transform 0.2s ease',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.boxShadow = '0 8px 24px rgba(139, 95, 191, 0.12)';
                        e.currentTarget.style.transform = 'translateY(-2px)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.boxShadow = 'none';
                        e.currentTarget.style.transform = 'none';
                      }}
                    >
                      <h2 style={{
                        margin: '0 0 8px 0',
                        color: '#1F2937',
                        fontSize: '1.4rem',
                        fontWeight: '700',
                      }}>
                        {post.title}
                      </h2>

                      <p style={{
                        color: '#8B5FBF',
                        fontSize: '0.85rem',
                        fontWeight: '600',
                        margin: '0 0 12px 0',
                      }}>
                        {post.persona_first_name && <span>By {post.persona_first_name} &bull; </span>}
                        {formatDate(post.created_at)}
                      </p>

                      <p style={{
                        color: '#4B5563',
                        lineHeight: '1.6',
                        margin: '0 0 12px 0',
                      }}>
                        {post.excerpt}
                      </p>

                      <span style={{ color: '#6B46C1', fontWeight: '600', fontSize: '0.95rem' }}>
                        Read more &rarr;
                      </span>
                    </article>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </section>

        <Footer />
      </main>
    </div>
  );
}

export default BlogList;
